import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TimeSheetservice } from '../time-stamp.service';
import { MatTableDataSource } from '@angular/material/table';
import * as XLSX from 'xlsx';
 
import { forEach } from 'jszip';
import moment from 'moment';
import Highcharts from 'highcharts';
@Component({
  selector: 'app-linechart-dialog',
  templateUrl: './linechart-dialog.component.html',
  styleUrls: ['./linechart-dialog.component.css']
})
export class LinechartDialogComponent {
  empIdList: string[];
  getCommentsData: any[] = [];
  displayedColumns: string[] = ['EmployeeId', 'EmployeeName', 'ProjectName', 'ManagerName', 'DifferDates', 'Count'];
  displayedColumnsProjectWise: string[] = ['ProjectName', 'ManagerName', 'Count'];
  dataSource: any;
  dataSource1: any;
  employeeData: any;
  totalEmployeeCount: number = 0;
  totalProjectCount: number = 0;
  selected: string = 'employeeWise';
  getCommentsData1: any[] = [];
  projectIdList: any[] = [];
  startDate: string;
  endDate: string;
  chart: Highcharts.Chart;
  isGraphView:boolean = false;
 
  constructor(
 
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LinechartDialogComponent>,
    private timeSheetService: TimeSheetservice
  ) { }
 
  ngOnInit() {
    const today = new Date();
    this.startDate = moment(today).subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
    this.endDate = moment(today).subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
    this.empIdList = this.data?.empName.map(x => x.id.toString());
    this.projectIdList = this.data?.projectName.map(x => x.id);
    this.timeSheetService.getCommentsList(this.empIdList).subscribe(
      (response: any) => {
        for (var ele of response?.data) {
          const empData = this.data?.empName.filter(x => x.id === Number(ele.employeeId));
          for (var data of ele.commentsData) {
            const projectName = this.data?.projectName?.filter(x => x.id === data.projectId);
            const ManagerData = projectName[0].deliveryManager;
            let dataIn = this.getCommentsData?.filter(x => x.ProjectId === data.projectId && x.EmployeeId === ele.employeeId);
            if (dataIn.length <= 0) {
              this.getCommentsData?.push({
                EmployeeId: ele?.employeeId,
                ManagerName: ManagerData,
                DifferDates: data?.differdates,
                EmployeeName: empData[0]?.name,
                ProjectId: data?.projectId,
                ProjectName: projectName[0]?.name,
                Count: 1
              });
            }
            else {
              let index = this.getCommentsData.findIndex(x => x.ProjectId === data.projectId);
              this.getCommentsData[index].DifferDates.push(...data?.differdates);
              // this.getCommentsData[dataIn].differDates
              this.getCommentsData[index].Count += 1
            }
          }
 
        }
        this.applyDateFilter();
      },
      error => {
        console.error('API error:', error);
        // Handle the error here
      }
    );
    this.timeSheetService.getDifferHistory(this.projectIdList).subscribe(
      (response: any) => {
        for (const ele of response?.data) {
          if (ele?.count > 0) {
            const projectName = this.data.projectName?.find(x => x.id === ele.projectId);
            const manager = projectName.deliveryManager;
            this.getCommentsData1?.push({
              ProjectName: projectName?.name,
              ManagerName: manager,
              Count: ele?.count
            });
 
          }
        }
        this.dataSource1 = new MatTableDataSource(this.getCommentsData1);
        this.totalProjectCount = this.dataSource1.filteredData.length;
      },
      error => {
        console.error('API error:', error);
        // Handle the error here
      }
    );
 
 
  }
 
  closeDialog() {
    this.dialogRef.close();
  }
  exportData() {
    let flattenedHeaders = [];
    let dataRows = [];
    let fileName = '';
 
 
    if (this.selected == 'employeeWise') {
      fileName = 'EmployeeData.xlsx';
      this.displayedColumns.forEach(header => {
        flattenedHeaders.push(header);
      });
 
      dataRows = this.employeeData.map(att => {
        const row = [];
 
        flattenedHeaders.forEach(header => {
 
          row.push(att[header] || '');
 
        });
        return row;
      });
 
    }
    else {
      fileName = 'ProjectData.xlsx';
 
      this.displayedColumnsProjectWise.forEach(header => {
        flattenedHeaders.push(header);
      });
 
 
      dataRows = this.getCommentsData1.map(att => {
        const row = [];
 
        flattenedHeaders.forEach(header => {
 
          row.push(att[header] || '');
 
        });
        return row;
      });
    }
    const worksheetData = [flattenedHeaders, ...dataRows];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const columnWidths = flattenedHeaders.map(header => {
      let width = 20;
 
      return { width };
    });
    worksheet['!cols'] = columnWidths;
    flattenedHeaders.forEach((header, index) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index });
      if (!worksheet[cellAddress]) worksheet[cellAddress] = { t: 's', v: header }; // Ensure the cell exists
      worksheet[cellAddress].s = {
        fill: {
          patternType: "solid",
          fgColor: { rgb: "FFFF00" }  // Yellow color
        },
        font: {
          bold: true
        }
      };
    });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Attendance');
    XLSX.writeFile(workbook, fileName);
  }
  applyDateFilter() {
    this.employeeData = this.getCommentsData.filter((record) =>
      record.DifferDates.some(
        (date) => new Date(date) >= new Date(this.startDate) && new Date(date) <= new Date(this.endDate)
      )
    );
    this.dataSource = new MatTableDataSource(this.employeeData);
    this.totalEmployeeCount = this.dataSource.filteredData.length;
  }
  getdata(event){
    if (event) {
      this.isGraphView = event.checked;
    }
    if(this.isGraphView){
      let xdata = [];
    let ydata = [];
    this.employeeData.forEach(element => {
      xdata.push(element.EmployeeName);
      ydata.push(element.Count);
    });
    setTimeout(()=>{
      var options: Highcharts.Options = {
        chart: {
          renderTo: 'chartContainer',
          type: 'line'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: xdata,
          title:{
            text: 'Employee Names'
          }
        },
        yAxis: {
          title: {
            text: 'Count'
          }
        },
        series: [{
          name: 'Count',
          data: ydata
        } as Highcharts.SeriesLineOptions]
      };
      var chart = new Highcharts.Chart(options);
    },1000);
   
 
    }
   
  }
}
 
 